import React from 'react';
import { useSystemEmailSettings } from '../hooks/use-system-email-settings.js';
import SystemEmailSettingsPageView from './system-email-settings-page-view.jsx';

function SystemEmailSettingsPageContainer() {
  const state = useSystemEmailSettings();
  return <SystemEmailSettingsPageView {...state} />;
}

export default SystemEmailSettingsPageContainer;
